import template from './invoice-report.html';
import controller from './invoice-report.controller';

let invoiceReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default invoiceReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/invoice-report/invoice-report.component.js